//Must stay the FIRST import: rewrites /bsm -> /bsm2026 etc. before App loads (pageAliasRedirect.js)
import './pageAliasRedirect';
import React from 'react';
import './index.css';
import App from './components/app/App';
import * as serviceWorker from './serviceWorker';
import { UserProvider } from './contexts/UserContext';
import { BrowserRouter } from 'react-router-dom';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <UserProvider>
      <App />
    </UserProvider>
  </BrowserRouter>
);

document.title = 'Club Wealth University';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
